import * as React from "react";
import ReactTable from "react-table";
import {Tarea, FiltroTarea} from "../modelo/Tarea";
import {Glyphicon, ButtonToolbar, OverlayTrigger, Tooltip} from "react-bootstrap";
import {EstadoTarea} from "../modelo/EstadosTarea";
import {REQUEST} from "../../../config/ajax-wrapper";
import {Mensaje} from "../../general/componentes/Mensaje";
import {DotLoader} from "react-spinners";

export default class TablaTareas extends React.Component<TablaTareasProps, any> {
    columns = [{
        Header: "Identificación",
        accessor: "afiliado.identificacion",
    }, {
        Header: "Tipo Cliente",
        accessor: "tipoCliente.nombre",
    }, {
        Header: "Estado",
        accessor: "estado"
    }, {
        Header: "Tipo Gestión",
        accessor: "tipoGestion"
    }, {
        Header: "Fecha Envío",
        accessor: "fechaRegistro"
    }, {
        Header: "Fecha Respuesta",
        accessor: "fechaRespuesta"
    }, {
        Header: "Póliza - Inicia Cobertura",
        accessor: "poliza",
        Cell: props => (
            <div className={"text-center"}>
                {this.renderFechaCobertura(props)}
            </div>
        )
    }, {
        Header: "Observación",
        accessor: "observacion",
        Cell: props => (
            <div className={"text-center"}>
                <ButtonToolbar>
                    <OverlayTrigger placement="top"
                                    overlay={
                                        <Tooltip id="tooltip">
                                            {this.renderObservacion(props)}
                                        </Tooltip>}>
                        <span className={"btns " + (this.obtenerClassName(props.original.estado))}><Glyphicon
                            glyph={"open"}/> Ver</span>
                    </OverlayTrigger>
                </ButtonToolbar>
            </div>
        )
    }, {
        Header: "Tarea Procesada",
        accessor: "estado",
        Cell: props => (
            <div className={"text-center"}>{
                this.renderEstado(props)
            }</div>
        ),
    }];

    renderObservacion = (props: any) => {
        if (props.original.estado === EstadoTarea.pendiente) {
            return ``;
        } else {
            return props.value;
        }
    }

    renderFechaCobertura = (props: any) => {
        if(props.original.estado === EstadoTarea.aprobado) {
            return(`${props.value} - ${props.original.fechaInicioCobertura}`);
        } else { 
            return (``);
        }
    } 

    renderEstado = (props: any) => {
        switch (props.value) {
            case EstadoTarea.error:
                return (
                    <a title={"Reintentar"} className={"btns btns-primary"}
                       onClick={() =>
                           this.props.onReintentar(
                               props.original.afiliado.identificacion, props.original.tipoCliente.id
                           )}>
                        <Glyphicon glyph={"refresh"}/> Reintentar</a>
                );
            case EstadoTarea.pendiente:
                return (
                    <span className={"btns btns-primary"}><Glyphicon glyph={"transfer"}/></span>
                );
            case EstadoTarea.rechazo:
                return(
                    <span className={"btns btns-primary"}><Glyphicon glyph={"ok"}/></span>
                );
            default:
                return (
                    <span className={"btns btns-primary"}><Glyphicon glyph={"ok"}/></span>
                );
        }
    }

    render() {
        const {tareas, estado, paginas, tamanoPagina, paginaActual} = this.props;
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error reintentando la tarea."}/>;
            case REQUEST.PENDING:
                return <DotLoader size={25}/>;
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"}
                                 mensaje={"La tarea se ha enviado para su procesamiento exitosamente."}/>
                        {this.renderTareas(tareas, paginas, tamanoPagina, paginaActual)}
                    </span>
                );
            default:
                return this.renderTareas(tareas, paginas, tamanoPagina, paginaActual);
        }
    }

    renderTareas(tareas: Array<Tarea>, paginas: number, tamanoPagina: number, paginaActual: number) {
        let numRegistros = 0;

        if (tareas.length < tamanoPagina) {
            numRegistros = tareas.length;
        } else {
            numRegistros = tamanoPagina;
        }

        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{tareas.length}</span> Tareas encontradas
                    </h2>
                </div>
                <ReactTable data={tareas}
                            columns={this.columns}
                            manual
                            defaultPageSize={numRegistros}
                            pageSizeOptions={this.calcularOpciones(numRegistros)}
                            page={paginaActual}
                            previousText={"Anterior"}
                            nextText={"Siguiente"}
                            loadingText={"Cargando..."}
                            noDataText={"No se ha encontrado información."}
                            pageText={"Página"}
                            ofText={"de"}
                            rowsText={""}
                            className={"-highlight -striped"}
                            pages={paginas}
                            onPageChange={(pageIndex) => {
                                this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                            }}
                            onPageSizeChange={(pageSize, pageIndex) => {
                                this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                            }}
                />
            </div>
        );
    }


    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroTarea: FiltroTarea = {
            dni: this.props.filtroTarea.dni,
            tipoCliente: this.props.filtroTarea.tipoCliente,
            estado: this.props.filtroTarea.estado,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex,
            dniUsuario: this.props.filtroTarea.dniUsuario,
            isSuper: this.props.filtroTarea.isSuper,
            fechaInicio: this.props.filtroTarea.fechaInicio,
            fechaFin: this.props.filtroTarea.fechaFin
        };
        this.props.consultaPaginada(filtroTarea);
    }


    obtenerClassName(estado: string) {
        return estado === EstadoTarea.error ? "btn-danger" : "btns-primary";
    }

    calcularOpciones(tamanoPagina : number) {
        const arreglo = [20, 30, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if( elemento ) {
            return arreglo;
        } else {
            return [...arreglo,tamanoPagina].sort((a, b) => {return a-b;} );
        }
     }

}

interface TablaTareasProps {
    tareas: Array<Tarea>,
    estado: REQUEST,
    filtroTarea: FiltroTarea,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    onReintentar?: (identificacion: string, tipoCliente: string) => void,
    consultaPaginada?: (filtroTarea: FiltroTarea) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/bandeja/componentes/TablaTareas.tsx